import { useEffect, useState } from 'react';

import { message } from 'antd';
import { useNavigate } from 'react-router-dom';

import BULK_UPLOADER_TITLE from './constants';
import apiConfig from '../../API_Utils/APIUtil/ApiConfig';
import CallApi from '../../API_Utils/APIUtil/CallApi';
import { getError, validator } from '../../clientUtils';
import SingleStepUploader from '../../Components/BulkUploader/SingleStepUploader';
import { BULK_UPLOAD_INVOICE_TYPES, FILE_TYPE_ATTRIBUTE } from '../../constants';

const POAllocation = () => {
  const [files, setFiles] = useState([]);
  const [savedFile, setSavedFile] = useState();
  const [sampleDownloadLink, setSampleDownloadLink] = useState(null);
  const [loading, setLoading] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const naviagate = useNavigate();
  useEffect(() => {
    CallApi(
      apiConfig.bulkUploader.poAllocation.sample,
      { invoice_type: BULK_UPLOAD_INVOICE_TYPES.DOMESTIC_ONLINE },
      undefined,
      setLoading,
      (res) => setSampleDownloadLink(res),
      (res) => message.error(getError(res))
    );
  }, []);

  const SKUListUploadProps = {
    title: 'PO Allocation',
    description: 'Please upload the list of SKUs (in CSV format with max file size of 5 MB)',
    sampleDownloadText: 'Download Sample file',
    sampleDownloadLink,
    accept: FILE_TYPE_ATTRIBUTE.csv,
    files,
    validator,
    onUpload: (file) => {
      setSavedFile(file);
      CallApi(
        apiConfig.bulkUploader.poAllocation.validate,
        { invoice_type: BULK_UPLOAD_INVOICE_TYPES.DOMESTIC_ONLINE },
        { file },
        undefined,
        (res) => setFiles([res]),
        (res) => message.error(getError(res))
      );
    },
    onRemove: async () => {
      setFiles([]);
      message.success('File deleted successfully!');
    }
  };
  const uploaderProps = {
    message: '',
    items: [SKUListUploadProps]
  };

  const isSubmitDisabled = () => {
    if (!files || files.length < 1) return true;
    if (files[0]?.summary?.failure > 0) return true;
    return false;
  };

  const handleSubmit = () => {
    CallApi(
      apiConfig.bulkUploader.poAllocation.submit,
      { invoice_type: BULK_UPLOAD_INVOICE_TYPES.DOMESTIC_ONLINE },
      { file: savedFile },
      setSubmitting,
      () => message.success('File submitted Successfully'),
      (res) => message.error(getError(res)),
      () => naviagate(0)
    );
  };

  return (
    <SingleStepUploader
      loading={loading}
      onSubmit={handleSubmit}
      openGroup={['bulkUploaders']}
      selectionKey="po-allocation-bulk"
      submitDisabled={isSubmitDisabled()}
      submitting={submitting}
      title={BULK_UPLOADER_TITLE['po-allocation']}
      uploaderProps={uploaderProps}
    />
  );
};

export default POAllocation;
